import {
  ActionReducer,
  ActionReducerMap,
  createFeatureSelector,
  createSelector,
  MetaReducer,
} from '@ngrx/store';
import * as fromGoal from '../store/goal/goal.reducer';
import * as fromAuth from '../store/auth/auth.reducer';
import { environment } from '../../environments/environment';
import * as fromResume from '../store/resume/resume.reducer';
import * as fromAssessment from '../store/assessment/assessment.reducer';

export const stateFeatureKey = 'state';

export interface State {
  assessments: fromAssessment.State;
  resumes: fromResume.State;
  goals: fromGoal.State;
  auth: fromAuth.State;
}

export const reducers: ActionReducerMap<State> = {
  assessments: fromAssessment.reducer,
  resumes: fromResume.reducer,
  goals: fromGoal.reducer,
  auth: fromAuth.reducer,
};

export const metaReducers: MetaReducer<State>[] = !environment.production
  ? []
  : [];
